const MAPPING = {
  'pt-PT': 'pt',
};

export function getFormatterLocale(locale) {
  return MAPPING[locale] || locale;
}
